import { render, staticRenderFns } from "./index-lotto.vue?vue&type=template&id=11cbeb13"
import script from "./index-lotto.vue?vue&type=script&lang=js"
export * from "./index-lotto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11cbeb13')) {
      api.createRecord('11cbeb13', component.options)
    } else {
      api.reload('11cbeb13', component.options)
    }
    module.hot.accept("./index-lotto.vue?vue&type=template&id=11cbeb13", function () {
      api.rerender('11cbeb13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/lotto/index-lotto.vue"
export default component.exports